import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhyLimaDental() {
  const benefits = [{
    title: 'Nearly invisible aligners',
    description: "Straighten your teeth discreetly. Most people won't even know you're wearing them."
  }, {
    title: 'Personalized care by Dr. Lima',
    description: "You won't see a different doctor every visit. Dr. Lima personally oversees your entire treatment."
  }, {
    title: 'Warm, family-run practice',
    description: 'We are a local family business, not a corporate chain with quotas to meet.'
  }, {
    title: '35+ years of trusted care',
    description: 'Deeply rooted in the Miami Lakes community with thousands of successful smiles.'
  }, {
    title: 'Flexible payment options',
    description: 'We make your dream smile affordable with flexible financing plans.'
  }];
  return <section className="py-10 lg:py-20 bg-brand-darkAlt" data-id="element-222">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-223">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-224">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-225">
            <h2 className="text-3xl md:text-4xl font-light text-white mb-4 lg:mb-6" data-id="element-226">
              Why Patients Choose Lima Dental for Invisalign
            </h2>
            <p className="text-lg text-white/60 mb-6 lg:mb-8" data-id="element-227">
              Getting Invisalign is an investment in yourself. You deserve a
              doctor who treats you like family, not just another chart number.
            </p>

            <div className="space-y-4 lg:space-y-6" data-id="element-228">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex gap-4" data-id="element-229">
                  <div className="flex-shrink-0 mt-1" data-id="element-230">
                    <CheckCircle2 className="w-6 h-6 text-brand-cream" data-id="element-231" />
                  </div>
                  <div data-id="element-232">
                    <h4 className="text-lg font-medium text-white mb-1" data-id="element-233">
                      {benefit.title}
                    </h4>
                    <p className="text-white/60" data-id="element-234">{benefit.description}</p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative h-[500px] rounded-2xl overflow-hidden hidden lg:block" data-id="element-235">
            <img src="https://cdn.magicpatterns.com/uploads/1cKWGE9Y7hrKjDdnrwUpb3/hf_20260414_230212_0f4e3818-a602-47ed-9165-246917d9d0bb.png" alt="Woman placing Invisalign clear aligner" className="w-full h-full object-cover" data-id="element-236" />
          </motion.div>
        </div>
      </div>
    </section>;
}